// People & Legacy taxonomy (Phase 1)
export const PEOPLE_CATEGORIES = [
  {
    value: "teaching", label: "Teaching & Academic",
    subs: ["Teacher", "Professor", "Assistant Professor", "Associate Professor", "Lecturer", "Senior Lecturer",
      "Instructor", "Tutor", "Teaching Assistant", "Research Faculty", "Visiting Faculty", "Adjunct Faculty",
      "Guest Lecturer", "Coach", "Trainer", "Laboratory Instructor", "Workshop Instructor", "Academic Librarian",
      "Academic Counselor", "Special Education Teacher", "Music Teacher", "Art Teacher", "Physical Education Teacher",
      "Language Teacher", "Vocational Instructor", "Religious Education Teacher", "Retired Faculty"],
  },
  {
    value: "leadership", label: "Educational Leadership",
    subs: ["Principal", "Headmaster", "Headmistress", "Vice Principal", "Dean", "Vice Dean", "Department Head",
      "Chairperson", "Director", "Academic Director", "Superintendent", "President", "Vice President", "Chancellor",
      "Vice Chancellor", "Provost", "Registrar", "Trustee", "Governor", "School Manager", "Correspondent", "Administrator"],
  },
  {
    value: "non_teaching", label: "Non-Teaching Staff",
    subs: ["Office Staff", "Administrative Assistant", "Secretary", "Accountant", "Finance Staff", "Admissions Staff",
      "Student Services Staff", "Librarian", "Library Assistant", "Laboratory Technician", "IT Staff", "Maintenance Staff",
      "Groundskeeper", "Gardener", "Security Staff", "Driver", "Bus Driver", "Conductor", "Cafeteria Staff", "Cook",
      "Kitchen Staff", "Custodian", "Janitor", "Housekeeping Staff", "Nurse", "Medical Staff", "Counselor", "Warden",
      "Hostel Staff", "Sports Staff", "Equipment Manager", "Clerk", "Receptionist", "Storekeeper", "Technician",
      "Electrician", "Plumber", "Carpenter", "Other"],
  },
];

export const PERSON_STATUSES = [
  { value: "active", label: "Active" },
  { value: "retired", label: "Retired" },
  { value: "former", label: "Former Staff" },
  { value: "deceased", label: "Deceased" },
  { value: "unknown", label: "Unknown" },
];

export const MEMORIAL_ACTIONS = [
  { value: "flower", label: "Leave a Flower", icon: "🌹" },
  { value: "candle", label: "Light a Candle", icon: "🕯️" },
  { value: "respect", label: "Pay Respect", icon: "🙏" },
];

export const subsFor = (cat) => (PEOPLE_CATEGORIES.find((c) => c.value === cat)?.subs) || [];
